const apiUrl = process.env.REACT_APP_API_URL?.trim();

if (!apiUrl) {
  throw new Error(
    'REACT_APP_API_URL ortam değişkeni tanımlı değil. Çalışma moduna uygun ortam dosyasındaki API adresini ayarlayın.'
  );
}

export const env = Object.freeze({
  apiUrl: apiUrl.replace(/\/+$/, ''),
});
